module.exports = __webpack_public_path__ + "img/placeholder/logo-compassion.svg";